import React, { useState, useRef, useEffect } from "react";
import classes from "./styles/style.module.css";
import SearchIcon from "../../images/icons/MagnifierIcon.svg";
import { DashboardMenuItems } from "../../../pages/DashBoard/DashboardMenu/DashboardMenuItems";
import { RxCross2 } from "react-icons/rx";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router";
import useLoginActions from "../../Hooks/Login";

const variants = {
  enter: {
    x: 0,
    opacity: 1,
    transition: { duration: 0.2 },
  },
  exit: {
    x: 20,
    opacity: 0,
    transition: { duration: 0.2 },
  },
};

const searchBoxVariants = {
  hidden: {
    opacity: 0,
    y: -20,
    transition: {
      duration: 0.2,
    },
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.2,
    },
  },
};

const DashboardSearchInput = () => {
  const [searchVal, setSearchVal] = useState("");
  const [filteredItems, setFilteredItems] = useState([]);
  const containerRef = useRef(null);
  const navigate = useNavigate();
  const { handleLogout } = useLoginActions();

  const handleClickOutside = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setFilteredItems([]);
      setSearchVal("");
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchVal(value);
    if (value.trim() !== "") {
      const filtered = DashboardMenuItems.flatMap((group) =>
        group.items.filter((item) =>
          item.itemName.toLowerCase().includes(value.toLowerCase())
        )
      );
      setFilteredItems(filtered);
    } else {
      setFilteredItems([]);
    }
  };

  const handleClickItem = (link, action) => {
    if (link !== "") {
      if (link.includes("http")) {
        window.open(link, "_blank");
      } else {
        navigate(link);
      }
    } else if (action) {
      if (action === "logOut") {
        handleLogout();
      }
    }
  };

  return (
    <div className={classes.searchContainer} ref={containerRef}>
      <div className={classes.SearchInpContainer}>
        <div className={classes.iconContainer}>
          <AnimatePresence mode="wait">
            {searchVal !== "" ? (
              <motion.div
                key="clearIcon"
                initial="exit"
                animate="enter"
                exit="exit"
                variants={variants}
                className={classes.icon}
                onClick={() => setSearchVal("")}
              >
                <RxCross2 size={25} />
              </motion.div>
            ) : (
              <motion.img
                key="searchIcon"
                src={SearchIcon}
                alt="search icon"
                initial="exit"
                animate="enter"
                exit="exit"
                variants={variants}
                className={classes.icon}
              />
            )}
          </AnimatePresence>
        </div>
        <input
          type="text"
          value={searchVal}
          onChange={handleSearchChange}
          placeholder="جست و جو"
        />
      </div>
      <AnimatePresence>
        {searchVal && (
          <motion.div
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={searchBoxVariants}
            className={`${classes.searchBox} shadow-lg`}
          >
            {filteredItems.length > 0 ? (
              filteredItems.map((item, index) => (
                <p
                  key={index}
                  onClick={() => handleClickItem(item.link, item?.action)}
                >
                  {item.itemName}
                </p>
              ))
            ) : (
              <p className="text-center">نتیجه‌ای یافت نشد!!</p>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default DashboardSearchInput;
